module.exports = __webpack_public_path__ + "band_2.4be65c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_2.png
// module id = EZLs
// module chunks = 0